'use strict';

(function() {
  function initHomeGrid(section) {
    var tabs = section.querySelectorAll('[data-ns-grid-tabs] .ns-home-grid__tab');
    var panels = section.querySelectorAll('[data-ns-grid-panels] .ns-home-grid__panel');

    if (!tabs.length) return;

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var idx = parseInt(tab.dataset.tabIndex, 10);

        // Update tab active states
        tabs.forEach(function(t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        // Update panel active states
        panels.forEach(function(p) { p.classList.remove('is-active'); });
        if (panels[idx]) panels[idx].classList.add('is-active');
      });
    });
  }

  function init() {
    document.querySelectorAll('.ns-home-grid').forEach(initHomeGrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
